export const OverallStatusNames = {
  Upcoming: "Kommende",
  Active: "Aktiv",
  Expired: "Udløbet",
};
